exports.ScopeEnums = {
  base: 'auth_base',
  info: 'auth_user'
};

exports.PaymentStatus = {
  9000: '订单支付成功',
  8000: '正在处理中',
  4000: '订单支付失败',
  6001: '用户中途取消',
  6002: '网络连接出错',
  99: '用户取消支付'// '用户点击忘记密码快捷界面退出'
};

exports.PaymentStatusCode = {
  9000: 'PAID',
  8000: 'PAYING',
  4000: 'FAILED',
  6001: 'UNPAID',
  6002: 'UNPAID',
  99: 'UNPAID'
};
